<template>
    <sections>
        <section-title
            v-bind="{
                heading: 'PRICES',
                content: '<p>Secure locks supplied and fitted</p>',
            }"
        ></section-title>
        <section-text-columns
            v-bind="{
                contentColumn1: '<article-prices-text-left />',
                contentColumn2: '<article-prices-text-right />',
            }"
        ></section-text-columns>
        <section-cards
            v-bind="{
                padding: 'pb-12 sm:pb-14',
                cards: [
                    {
                        image: $config.public.images + 'onelock.jpg',
                        imageAspectRatio: 'aspect-[11/9]',
                        heading: '1 x ABS Lock',
                        excerpt: '<p>1 ABS Lock Fitted - £75</p>',
                    },
                    {
                        image: $config.public.images + 'twolocks.jpg',
                        imageAspectRatio: 'aspect-[11/9]',
                        heading: '2 x ABS Locks',
                        excerpt: '<p>2 ABS Locks Fitted - £130</p>',
                    },
                    {
                        image: $config.public.images + 'threelocks.jpg',
                        imageAspectRatio: 'aspect-[11/9]',
                        heading: '3 x ABS Locks',
                        excerpt: '<p>3 ABS Locks Fitted - £180</p>',
                    },
                    {
                        image: $config.public.images + 'onextra.jpg',
                        imageAspectRatio: 'aspect-[11/9]',
                        heading: '4 x ABS Locks',
                        excerpt: '<p>4 ABS Locks Fitted - £230</p>',
                    },
                ],
            }"
        ></section-cards>
        <section-text
            v-bind="{
                color: 'bg-zinc-900',
                content: '<article-prices-footnote />',
            }"
        ></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Prices | ' + $config.public.siteName,
    description: 'Secure locks supplied and fitted.',
    index: true,
});
</script>
